import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { FaLinkedin, FaInstagram, FaFacebook, FaYoutube } from 'react-icons/fa';

const Footer = () => {
  const navigate = useNavigate();

  const handleScrollToOffice = () => {
    navigate('/contact');
    setTimeout(() => {
      const section = document.getElementById('office');
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }, 200);
  };

  return (
    <footer className="bg-black text-gray-300">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

          {/* Column 1: Logo and Description */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <img src="assets/realation white.png" alt="Propweb Logo" className="w-52" />
            </Link>
            <p className="mt-6 text-sm">
             REALATION is your trusted partner in real estate mandate solutions, bridging developers and buyers with innovative strategies and seamless execution.
            </p>
            <div className="flex mt-6 space-x-4 text-white text-xl">
              <a
                href="https://www.linkedin.com/company/realation-official/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="hover:text-[#0A66C2]"
              >
                <FaLinkedin />
              </a>
              <a
                href="https://www.instagram.com/realation_official?igsh=MXBieGhqNXg4ZDB6YQ=="
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="hover:text-[#E1306C]"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=100088421362780#"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="hover:text-[#1877F2]"
              >
                <FaFacebook />
              </a>
              <a
                href="https://www.youtube.com/@realation6580"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                className="hover:text-[#FF0000]"
              >
                <FaYoutube />
              </a>
            </div>
          </div>

          {/* Column 2: Head Office */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Head Office</h3>
            <p className="text-sm space-y-1 not-italic">
              <span className="font-medium text-gray-200 block">Realation Property Consultant LLP</span>
              Corporate Office 405, 4th Floor, One Platinum, Plot No 8, Sector 15, CBD Belapur, Navi Mumbai, Maharashtra 400614
            </p>
            <button
              onClick={handleScrollToOffice}
              className="mt-4 text-[#741112] underline hover:text-white text-sm transition-colors"
            >
              View All Locations
            </button>
          </div>

          {/* Column 3: Quick Links */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-[#741112]">Home</Link></li>
              <li><Link to="/about" className="hover:text-[#741112]">About</Link></li>
              <li><Link to="/services" className="hover:text-[#741112]">Services</Link></li>
              <li><Link to="/career" className="hover:text-[#741112]">Career</Link></li>
              <li><Link to="/contact" className="hover:text-[#741112]">Contact Us</Link></li>
            </ul>
          </div>
        </div>

        <hr className="my-8 border-gray-700" />

        {/* Footer Bottom */}
        <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} PropWeb. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
